import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import './styles/search_page.scss';

export default class SearchPage extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string
  };

  render() {
    return (
      <div className={classNames('search-page', this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}
